import { trpc } from "@api/client";

interface UseQueryOptions {
  onError?: (error: unknown) => void;
}

export const useGetSetup = (
  companyId: string,
  { onError }: UseQueryOptions = {}
) => {
  const { data, refetch, error, isLoading } = trpc.getSetup.useQuery(
    { companyId },
    { enabled: !!companyId, retry: false, onError }
  );

  return { setup: data, refetch, error, isLoading };
};
